import axios from 'axios'
import { CADASTRAR_IMPOSTO_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarImpostoEmpresa (impostoEmpresa) {
  const url = `${URL}/imposto-empresa/cadastrar`;
  return dispatch => axios.post(url, impostoEmpresa, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_IMPOSTO_EMPRESA,
        payload: response
      })
  );
}
